import { nanoid } from 'nanoid';
import { useState, useEffect } from 'react';

const useGenerateSpecialUrl = ({ propsIframeSrc, params, firstTab, type }) => {
    const [iframeDomain, setIframeDomain] = useState('');
    const [iframeSrc, setIframeSrc] = useState('');
    const [iframeId] = useState(nanoid);
    const defaultUrl = `${iframeDomain}/special-offers/${type === 'verticalList' ? 'vertical/' : ''}`;
    useEffect(() => {
        if (propsIframeSrc) {
            setIframeDomain(propsIframeSrc);
        }
        else {
            setIframeDomain(window.location.protocol +
                '//' +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port : ''));
        }
    }, [propsIframeSrc]);
    useEffect(() => {
        if (!iframeDomain)
            return;
        const allParams = {
            ...params,
            iframeId,
        };
        const url = new URL(defaultUrl);
        Object.entries(allParams).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => url.searchParams.append(key, v));
            }
            else if (value) {
                url.searchParams.set(key, value.toString());
            }
        });
        url.searchParams.set('firstTab', firstTab.type);
        if (firstTab.subtype) {
            url.searchParams.set('subproduct', firstTab.subtype);
        }
        if (type === 'verticalList') {
            url.searchParams.set('tabType', firstTab.type);
            firstTab.subtype && url.searchParams.set('subproduct', firstTab.subtype);
        }
        setIframeSrc(url.toString());
    }, [defaultUrl, firstTab, iframeDomain, iframeId, params, type]);
    return {
        iframeDomain,
        iframeSrc,
        iframeId,
    };
};

export { useGenerateSpecialUrl };
//# sourceMappingURL=generateSpecialUrl.js.map
